import React from 'react'

const TrackReplaySVGTum = ({timelineInitialDate, timelineEndDate, timeLineTum,
     widthAux, handleMouseEnterTrackTUMSvg, handleMouseLeaveTrackTumSvg, transformTimelineData}) => {
  return (
    <>
    {timeLineTum.map((item, index) => {
        let marginx = index;
        let colorTrack = "red";
        if (item.status == "Operating") {
            colorTrack = "green";
        }
        if (item.status == "Standby") {
            colorTrack = "gray";
        }
        if (item.status == "Delay") {
            colorTrack = "yellow";
        }
        if (item.status == "Down") {
            colorTrack = "red";
        }
        var dataPosition = transformTimelineData(0,widthAux, timelineInitialDate,
                            timelineEndDate, item.initial_date, item.end_date
                            );
        return (
            <rect
            x={dataPosition.pixelPosition}
            y="80"
            width={dataPosition.statusWidth}
            height="20"
            rx="2"
            ry="2"
            fill={colorTrack}
            onMouseEnter={(e) =>handleMouseEnterTrackTUMSvg(e, item)}
            onMouseLeave={handleMouseLeaveTrackTumSvg}
            />
        );
    })
    }
    </>

  )
}

export default TrackReplaySVGTum